module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-wrapper spc"
  }, [(_vm.items && _vm.items.length) ? _vm._l(((_vm.readonly ? _vm.items.filter(function (fi) { return fi.id == _vm.curValue; }) : _vm.items)), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "spc__item",
      class: {
        'selected': item.id == _vm.curValue,
          'disabled': _vm.readonly || _vm.Props[item['id']]['disabled'],
          'not-active-item': item.active !== true,
          'narrow': _vm.crud === 'paymentauto' && _vm.action === 'create'
      },
      on: {
        "click": function($event) {
          return _vm.onItemClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "spc__item-text"
    }, [_c('div', {
      staticClass: "spc__item-name"
    }, [_c('div', {
      staticClass: "spc__item-logo"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + item.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "spc__item-pay-name"
    }, [_vm._v(_vm._s(_vm._f("ftc")(item.name)))])])]), _vm._v(" "), _c('div', {
      staticClass: "spc__item-info"
    }, [(item['comission'] > 0) ? _c('div', {
      staticClass: "spc__item-selector-info"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('payment/comission')) + ": " + _vm._s(item['comission']) + "%\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item['bonus'] > 0) ? _c('div', {
      staticClass: "spc__item-selector-info"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('payment/bonus')) + ": " + _vm._s(item['bonus']) + "%\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sm-sum"
    }, [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.Props[item['id']]['summa'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })]), _vm._v(" "), (_vm.getMin(item) && _vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['min'])) + " — " + _vm._s(_vm._f("moneyOnlyNumbers")(item['max'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.getMin(item) && !_vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("ftc")('main/range_from')) + " " + _vm._s(_vm._f("moneyOnlyNumbers")(item['min'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e(), _vm._v(" "), (!_vm.getMin(item) && _vm.getMax(item)) ? [_c('div', [_vm._v(_vm._s(_vm._f("ftc")('main/range_to')) + " " + _vm._s(_vm._f("moneyOnlyNumbers")(item['max'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "spc__item-trash",
      class: {
        empty: _vm.crud === 'paymentauto'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteSavedPayment(item.id)
        }
      }
    }, [(_vm.crud !== 'paymentauto') ? _c('font-awesome-icon', {
      attrs: {
        "icon": "trash-alt"
      }
    }) : _vm._e()], 1)])
  }) : (_vm.crud === 'paymentauto') ? void 0 : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b457e5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/savedPayments.vue
// module id = 431
// module chunks = 0